<div class="main d-flex gap-12 align-center flex-dir-col just-space">

<div class="date-picker d-flex width-100 just-space">
    <div class="form-field block d-flex">
        <div class="date-select space-flex d-flex">
            <input
                misTzDp
                class="h6"
                type="text"
                readonly
                [dpConfig]="startDatepickerConfig"
                class="form-field-input-text"
                placeholder="{{ 'Select' }}"
                positionX="start" 
                [(ngModel)]="selectedDate"
                (ngModelChange)="changeFormat1($event)"/>
            <img [src]="imgSrc + 'assets/icons/date-picker.svg'" alt="" class="date-icon data-picker-icon" />
        </div>
    </div>
        <button  class="transparent-button pointer-cursor"><img [src]="imgSrc + 'assets/icons/report.svg'"></button>
</div>


<div class="d-flex gap-8 align-center just-space width-100">
    <div><span class="h8-b grey">Trips</span></div>
    <div class="chip"><span class="h8">Completed </span><span class="h8-b">5/12</span></div>
    <div class="chip"><span class="h8">upcoming </span><span class="h8-b">6</span></div>
    <div class="chip"><span class="h8 red">Cancelled </span><span class="h8-b red">1</span></div>
</div>


       
</div>

 